import { LayoutService } from '../../../_service/layout.service';

/**
 * UI state and mode logic extracted from HomeComponent.
 * Handles UI toggles, view changes, and select mode management.
 */
export class UIStateLogic {
  /**
   * Toggle header visibility
   */
  static toggleHeaderVisibility(isHeaderVisible: boolean): boolean {
    return !isHeaderVisible;
  }

  /**
   * Toggle dark mode through layout service
   */
  static toggleDarkMode(layoutService: LayoutService): void {
    layoutService.appState.update((state) => ({
      ...state,
      darkMode: !state.darkMode,
    }));
  }

  /**
   * Update document body class for select mode styling
   */
  static updateBodySelectModeClass(isActive: boolean): void {
    if (typeof document === 'undefined') {
      return;
    }
    document.body.classList.toggle('select-mode-global', isActive);
  }

  /**
   * Determine if view switching is needed when entering/exiting select mode
   */
  static getViewForSelectMode(
    isEnabling: boolean,
    currentView: string,
    previousView: string | null,
  ): { view: string; previousView: string | null } {
    // No longer force view change - stay in current view when enabling select mode
    if (isEnabling) {
      return {
        view: currentView,
        previousView: previousView,
      };
    } else {
      return {
        view: currentView,
        previousView: null,
      };
    }
  }
}
